import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {StorageService} from '../../../../Services/storage.service';
import {HttpErrorResponse} from '@angular/common/http';
import {AppConfigService} from '../../../../Services/app-config.service';
import {NotificationService} from '../../../../Services/notification.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-account-margin-list',
  templateUrl: './account-margin-list.component.html',
  styleUrls: ['./account-margin-list.component.css'],
  standalone: false
})
export class AccountMarginListComponent extends ListPageBase implements OnInit, OnDestroy, AfterViewInit {

  constructor(
    private table: DataService,
    private toastr: NotificationService,
    private storage: StorageService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  accountMarginCount = 0;
  isLoaded = false;



  vm: any = [];

  ngOnInit(): void {
    this.vm.list = [];
    this.getData();
  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Account Margin List @@accountMarginList:Account Margin List`);
  }

  getData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('account_margin' + paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.accountMarginCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
      }
    );
  }

  onNavigate(aID: string) {
    this.router.navigate(['admin/account-margin-form', {id: aID}]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('account_margin' + paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.accountMarginCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
      }
    );
  }

  ngOnDestroy() {
    // no legacy datatable resources to clean
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
